"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkmark = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const checkmark = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'checkmark-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.9962 4.93762C16.3068 5.21167 16.3364 5.68562 16.0624 5.99621L8.56238 14.4962C8.4254 14.6515 8.23034 14.7432 8.0234 14.7496C7.81647 14.7561 7.61607 14.6767 7.46967 14.5303L3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96966C4.26256 9.67677 4.73744 9.67677 5.03033 9.96966L7.96582 12.9052L14.9376 5.00378C15.2117 4.69318 15.6856 4.66356 15.9962 4.93762Z', fill: '#4B5563' })));
};
exports.checkmark = checkmark;
